/**
 * Defines types for contact status.
 */
export const CONTACT_TYPE = {
  Prospect: 1,
  Customer: 2,
  Archived: 8,
};
